export default __webpack_public_path__ + "static/media/warning-red.c105a8f0.svg";